import { StockItemInterface, StockSelectOptionInterface } from '../types/stock';

export const generateSelectOption = (stock: StockItemInterface) => {
    const { stockNumber, licensePlate } = stock;

    const licensePlateValue = licensePlate !== null ? licensePlate : '';

    const obj: StockSelectOptionInterface = {
        label: stockNumber,
        value: {
            stockNumber: stockNumber,
            licensePlate: licensePlateValue,
        },
    };

    return obj;
};
